import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import classNames from "classnames";
import styles from "./CompositionChip.module.scss";
import VariableTag from "../VariableTag/VariableTag.component";
import OperatorTag from "../OperatorTag/OperatorTag.component";
import InvalidVariableTag from "../InvalidVariableTag/InvalidVariableTag.component";
import type {
  ChipTagProps,
  CompositionChipProps,
} from "./CompositionChip.types";
import type { FormulaChipModel } from "../FormulaEditor.types";

const renderChipTag = (model: FormulaChipModel, tagProps: ChipTagProps) => {
  if (model.isInvalidVariable) return <InvalidVariableTag {...tagProps} />;
  if (model.token.kind !== "var") return <OperatorTag {...tagProps} />;
  return <VariableTag {...tagProps} />;
};

const CompositionChip: React.FC<CompositionChipProps> = ({
  model,
  showInsertBar,
  onRemove,
}) => {
  const { token, label } = model;
  const { attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: token.uid,
  });

  const closeProps = {
    label: `Remove ${label}`,
    onPointerDown: (e: React.PointerEvent) => e.stopPropagation(),
    onClick: (e: React.MouseEvent) => {
      e.stopPropagation();
      onRemove(token.uid);
    },
  };

  return (
    <div
      ref={setNodeRef}
      className={classNames(styles.chip, {
        [styles.chipDragging]: isDragging,
        [styles.chipInsertBefore]: showInsertBar,
      })}
      {...attributes}
      role={undefined}
      {...listeners}
    >
      {renderChipTag(model, { label, closeProps })}
    </div>
  );
};

export default CompositionChip;
